export default __webpack_public_path__ + "static/media/black-hand-icon.e71752f1.svg";